import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService, ConfigService, ToastService } from 'msslib';

@Injectable({
  providedIn: 'root',
})
export class ClubHubDataService extends DataService {
  protected toastService: ToastService;
  protected configService: ConfigService;

  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const configService = inject(ConfigService);

    super(http, toastService, configService, configService.config.clubHubApiUrl);

    this.toastService = toastService;
    this.configService = configService;
  }
}
